export default __webpack_public_path__ + "static/media/bg-image-daytime.22955f11.jpg";